module.exports = __webpack_public_path__ + "img/C73424.e272ce43.png";